import { render } from "./personalCenter.vue?vue&type=template&id=22e4baad&scoped=true"
import script from "./personalCenter.vue?vue&type=script&lang=js"
export * from "./personalCenter.vue?vue&type=script&lang=js"

import "./personalCenter.vue?vue&type=style&index=0&id=22e4baad&lang=less&scoped=scoped"

import exportComponent from "E:\\claude_code\\healthmall\\tongue_desktop\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22e4baad"]])

export default __exports__